// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6c97079b1b--wrapper--v8A0r","quiz_completed":"_6c97079b1b--quiz_completed--9Ic1D","container":"_6c97079b1b--container--3X8ja"};